import { getBrandValue, getBrandAssetsPath } from './brand-helpers'
import { BrandVariationKeys } from '../feature-flags/models'

export const shellBrandingApi = {
  getBrandValue,
  BrandVariationKeys,
  getBrandAssetsPath,
}
